<template>
<div class="section section-2 py-md-5" id="inmunidad">
  <div class="container">
    <h2 class="text-center section__title-principal mb-3">Inmunidad por región</h2>
    <div class="wrapper dot-grid">
      <div class="row no-gutters">
        <div class="col-4 col-lg-6 border-right">
          <h5 class="text-selected-region text-center text-muted mb-0 pt-2">{{ regionesSelected }}</h5>
          <div class="box-rosadevientos">
            <img class="img-fluid d-none d-lg-block" src="../../assets/image/rosadelosvientos.png">
          </div>
          <radio-svg-map v-model="selectedRegion.text" :map="Taiwan" @click="getDataInfo"/>
        </div>
        <div class="col-8 col-lg-6">
          <div class="tasas py-2">
            <h5 class="text-center text-muted">Vacunación {{ regionesSelected }}</h5>
            <div class="col-12 col-md-12 d-flex justify-content-center">
              <div v-if="this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Porcentaje población objetivo']" class="progress w-100 align-self-center bar">
                <div class="progress-bar bg-color-primary" role="progressbar" :style="{'width' : this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Porcentaje población objetivo'] + '%'}"  :aria-valuenow="this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Porcentaje población objetivo']" aria-valuemin="0" aria-valuemax="100">
                  <div class="box-tasa-letter">
                  <p class="tasa__number--white">
                    {{ this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Porcentaje población objetivo'] + '%' }}
                  </p>
                  <p class="tasa__text--white d-none d-md-block d-lg-block">Población <br>inmunizada</p>
                  </div>
                </div>
                <div class="progress-bar bg-color-secundary" role="progressbar" :style="{'width' : porcentajePoblacionRestanteRegion + '%'}"  :aria-valuenow="porcentajePoblacionRestanteRegion" aria-valuemin="0" aria-valuemax="100">
                  <div class="box-tasa-letter">
                    <p class="tasa__number--white">
                      {{ porcentajePoblacionRestanteRegion +'%' }}
                    </p>
                    <div>
                      <p class="tasa__text--white d-none d-md-block d-lg-block">Población <br>restante</p>
                  </div>
                  </div>
                </div>
              </div>
              <div v-else class="progress w-100 align-self-center bar d-flex justify-content-center align-items-center">
                <p class="tasa__number">-</p>
              </div>
              <div class="tasa ml-3">
                <p v-if="this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Días para inmunidad de rebaño (70%)']" class="tasa__number">
                  {{ this.findDataRegion[1]['Días para inmunidad de rebaño (70%)'] }}
                </p>
                <p v-else class="tasa__number">-</p>
                <p class="tasa__text">DÍAS PARA INMUNIDAD</p>
              </div>
            </div>
          </div>
          <div class="col-12 d-block d-md-none d-lg-none">
            <div class="chart-legend">
              <ul class="legend">
                <li class="legend__item legend__item--solid">Población inmunizada</li>
              </ul>
              <ul class="legend">
                <li class="legend__item legend__item--solid">Población restante</li>
              </ul>
            </div>
          </div>
          <div class="tasas py-2">
            <div class="col-12 col-md-12 d-flex justify-content-center">
              <div class="tasa">
                <p v-if="this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Primera dosis']"  class="tasa__number">
                  {{ this.findDataRegion[1]['Primera dosis'] | numberWithCommas }}
                </p>
                <p v-else class="tasa__number">-</p>
                <p class="tasa__text">Primera dosis</p>
              </div>
              <div class="tasa">
                <p v-if="this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Personas inmunizadas']" class="tasa__number">
                  {{ this.findDataRegion[1]['Personas inmunizadas'] | numberWithCommas }}
                </p>
                <p v-else class="tasa__number">-</p>
                <p class="tasa__text">Segunda dosis</p>
              </div>
            </div>
          </div>
          <div class="tasas py-2">
            <div class="col-12 col-md-12 d-flex justify-content-center">
              <div class="tasa">
                <p v-if="this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Contagios']" class="tasa__number">
                  {{ this.findDataRegion[1]['Contagios'] | numberWithCommas }}
                </p>
                <p v-else class="tasa__number">-</p>
                <p class="tasa__text">Contagios</p>
              </div>
              <div class="tasa">
                <p v-if="this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Fallecidos']" class="tasa__number">
                  {{ this.findDataRegion[1]['Fallecidos'] | numberWithCommas }}
                </p>
                <p v-else class="tasa__number">-</p>
                <p class="tasa__text">Fallecidos</p>
              </div>
            </div>
          </div>
          <div class="tasas py-2">
            <h5 class="text-center text-muted">Vacunación en Chile</h5>
            <div class="col-12 col-md-12 d-flex justify-content-center">
              <div v-if="this.inmunizacionData && this.inmunizacionData.data && this.inmunizacionData.data.Total['Porcentaje población objetivo']" class="progress w-100 align-self-center bar">
                <div class="progress-bar bg-color-primary" role="progressbar" :style="{'width' : this.inmunizacionData && this.inmunizacionData.data && this.inmunizacionData.data.Total['Porcentaje población objetivo'] + '%'}"  :aria-valuenow="this.inmunizacionData && this.inmunizacionData.data && this.inmunizacionData.data.Total['Porcentaje población objetivo']" aria-valuemin="0" aria-valuemax="100">
                  <div class="box-tasa-letter">
                    <p class="tasa__number--white">
                      {{ this.inmunizacionData && this.inmunizacionData.data && this.inmunizacionData.data.Total['Porcentaje población objetivo'] + '%' }}
                    </p>
                    <p class="tasa__text--white d-none d-md-block d-lg-block">Población <br>inmunizada</p>
                  </div>
                </div>
                <div class="progress-bar  bg-color-secundary" role="progressbar" :style="{'width' : porcentajePoblacionRestanteChile + '%'}"  :aria-valuenow="porcentajePoblacionRestanteChile" aria-valuemin="0" aria-valuemax="100">
                  <div class="box-tasa-letter">
                    <p class="tasa__number--white">
                      {{ porcentajePoblacionRestanteChile +'%' }}
                    </p>
                    <p class="tasa__text--white d-none d-md-block d-lg-block">Población <br>restante</p>
                  </div>
                </div>
              </div>
              <div class="tasa ml-3">
                <p v-if="this.inmunizacionData && this.inmunizacionData.data && this.inmunizacionData.data.Total['Días para inmunidad de rebaño (70%)']" class="tasa__number">
                  {{ this.inmunizacionData.data.Total['Días para inmunidad de rebaño (70%)'] }}
                </p>
                <p v-else class="tasa__number">-</p>
                <p class="tasa__text">DÍAS PARA INMUNIDAD</p>
              </div>
            </div>
              <div class="col-12 d-block d-md-none d-lg-none">
                <div class="chart-legend pt-2">
                  <ul class="legend">
                    <li class="legend__item legend__item--solid">Población inmunizada</li>
                  </ul>
                  <ul class="legend">
                    <li class="legend__item legend__item--solid">Población restante</li>
                  </ul>
                </div>
              </div>
              <div class="col-12 col-md-12 pt-1">
                <small>Las barras representan el avance del plan de vacunación contra SARS-CoV-2 de la población objetivo definida en Chile, que asciende a 15.200.840 millones de personas y equivale al 77% de los habitantes del país. La cifra de días restantes para la inmunidad colectiva responde al cálculo entre el avance del plan y otras variables.</small>
              </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-start justify-content-md-end py-1">
        <p class="mb-0 text-fuente"><b>Fuente:</b> Elaboración propia a partir de DEIS - Minsal</p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { getInmunizacionChile, getRegiones } from '@/api'
import { RadioSvgMap } from "vue-svg-map"
import Taiwan from "@svg-maps/taiwan" //Observacion se tuve que modificar el mapa de taiwan para colocar el de chile ya que no existe el package
import { getRegionByDiario } from "../../api/regionbydiario";

export default {
  name: "mapsChile",
  components: {
    RadioSvgMap
  },
  data() {
    return {
      Taiwan,
      selectedRegion: {},
      pointedLocation: null,
      inmunizacionData: [],
      regiones: [],
      valueId: '',
      datos: [],
      findDataRegion: ''
    }
  },

  filters: {
    numberWithCommas(num) {
      return parseFloat(num)
        .toString()
        .replace((/\B(?=(\d{3})+(?!\d))/g), ".")
    },
  },

  computed: {
    regionesSelected() {
      if(this.selectedRegion.text === 'Maule' || this.selectedRegion.text === 'Biobío') {
        return 'Región del ' + this.selectedRegion.text
      }else if(this.selectedRegion.text === 'Araucanía') {
        return 'Región de la ' + this.selectedRegion.text
      }else if(this.selectedRegion.text === 'Metropolitana') {
        return 'Región ' + this.selectedRegion.text
      }else if(this.selectedRegion.text === ''){
        return 'Seleccione una Región'
      }else {
        return 'Región de ' + this.selectedRegion.text
      }
    },

    porcentajePoblacionRestanteRegion() {
      let num = 100
      if(this.findDataRegion && this.findDataRegion[1] && this.findDataRegion[1]['Porcentaje población objetivo']) {
        return num - parseInt(this.findDataRegion[1]['Porcentaje población objetivo'])
      }
        return '-'
    },

    porcentajePoblacionRestanteChile() {
      let num = 100
      if(this.inmunizacionData && this.inmunizacionData.data && this.inmunizacionData.data.Total['Porcentaje población objetivo']) {
        return num - parseInt(this.inmunizacionData.data.Total['Porcentaje población objetivo'])
      }
        return '-'
    }
  },
  methods: {
    getDataInfo() {
        this.findDataRegion = this.datos.find((element) => element[0] === this. selectedRegion.text)
    },

    getZonaById() {
      return this.regiones.find((element) => element.value === this.valueId)
    }
  },
  async mounted() {
    let id = window.app.idDiario;
    this.valueId = getRegionByDiario(id)
    this.regiones = await getRegiones()
    this.selectedRegion = this.getZonaById()
    this.inmunizacionData = await getInmunizacionChile()
    for (let [key, value] of Object.entries(this.inmunizacionData.data)) {
      this.datos.push([key, value])
    }
    this.findDataRegion = this.datos.find((element) => element[0] === this.selectedRegion.text)
  }
}
</script>

